import { apiGet, apiPost, apiPut, apiDelete } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import * as notifications from './notificationActions';
import { objectToQuery } from 'helpers/Formatter';

export function getShowings(options = {}) {
  // Options: show_all: true will return list of all tenants.
  let route = '/landlords/showings';
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_SHOWINGS::FETCH_SHOWINGS',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(displayShowings(response.showings, Date.now(), options.offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getFilteredShowings(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_SHOWINGS::FETCH_SHOWINGS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_showings?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(displayShowings(response.showings, Date.now(), offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getShowingStats() {
  const route = '/landlords/showing_stats';
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_SHOWINGS::FETCH_SHOWINGS_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'LANDLORD_SHOWINGS::SAVE_SHOWINGS_STATS',
          payload: response.detailed_showings_counts,
        });
      }),
    });
  };
}

export function getHistory(showingID) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/showings/${showingID}/history`)
        .done(response => {
          dispatch(displayHistory(response.booking_history));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getShowing(showingID) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/showings/${showingID}`)
        .done(response => {
          dispatch(displayShowing(response.booking));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayShowing(bookings) {
  return {
    type: 'LANDLORD_SHOWINGS::SHOW_SHOWING',
    showingDetails: bookings,
  };
}

export function displayShowings(response, timestamp, offset) {
  return {
    type: 'LANDLORD_SHOWINGS::SHOW_SHOWINGS',
    showings: response,
    timestamp,
    offset,
  };
}

export function displayHistory(response) {
  return {
    type: 'FETCH_HISTORY',
    bookingHistory: response,
  };
}

export function openNewShowingDialog() {
  return {
    type: 'SHOW_NEW_SHOWING_DIALOG',
    shouldShow: true,
  };
}

export function closeNewShowingDialog() {
  return {
    type: 'SHOW_NEW_SHOWING_DIALOG',
    shouldShow: false,
  };
}

export function postShowing(data, propertyId, bookTime, bookDate) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  data_clone.property_id = propertyId;
  data_clone.book_time = bookTime;
  data_clone.book_date = bookDate;
  data_clone.birthday = data['dob'];

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/showings/', data_clone)
        .done(response => {
          return dispatch(notifications.showSuccess('successfullyAddedShowing'));
        })
        .catch(error => {
          let failure =
            'It looks like that time is no longer available. Please select another time.';
          if (error.status === 422) {
            // it is a validation error
            failure = error;
          }
          dispatch(notifications.showFailure(failure));
          throw Error;
        }),
    });
  };
}

export function updatePropertyId(id) {
  return {
    type: 'UPDATE_PROPERTY_ID',
    id,
  };
}

export function openEditShowingDialog(showingDetails) {
  return {
    type: 'SHOW_EDIT_SHOWING_DIALOG',
    showingDetails: showingDetails,
    shouldShow: true,
  };
}

export function assignShowingToAgent(form_data, showing_id, property_id) {
  let data_clone = JSON.parse(JSON.stringify(form_data));

  if (data_clone['unit'] !== undefined) {
    data_clone['unit'] = data_clone['unit']['value'];
  }
  if (data_clone['assign'] !== undefined) {
    data_clone['assign'] = data_clone['assign']['value'];
  }
  data_clone.property_id = property_id;

  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/assign_showing/${showing_id}`, data_clone)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyAssignedShowing'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function closeEditShowingDialog() {
  return {
    type: 'SHOW_EDIT_SHOWING_DIALOG',
    showingDetails: {},
    shouldShow: false,
  };
}

export function putShowing(id, bookingParams) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/showings/${id}`, bookingParams)
        .done(response => {
          dispatch(getShowings());
          dispatch(notifications.showSuccess('successfullyUpdatedShowing'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function cancelBookingByAgent(booking_id, cancellation_reason = 'cancelled') {
  return dispatch => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() +
          `/landlords/showings/${booking_id}?cancellation_reason=${cancellation_reason}`
      )
        .done(response => {
          dispatch(notifications.showSuccess('Showing Successfully Cancelled.'));
          dispatch(getShowings());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function goToNextPage() {
  return {
    type: 'UPDATE_WIZARD_PAGE_NUMBER',
    wizardPageNumber: 2,
  };
}

export function goBackToPage() {
  return {
    type: 'UPDATE_WIZARD_PAGE_NUMBER',
    wizardPageNumber: 1,
  };
}

export function updateNewShowingDetails(newShowingDetails) {
  return {
    type: 'UPDATE_NEW_SHOWING_DETAILS',
    newShowingDetails,
  };
}
